'use client';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { IconExternalLink, IconGitHub } from './ui/icons';

import { Button } from '@/components/ui/button';
import { cn } from '../lib/utils';

const externalLinks = [
    {
        title: 'Pull Requests',
        href: 'https://github.com/parlii/chauncey-ai/pulls'
    },
    {
        title: 'Project Board',
        href: 'https://github.com/users/parlii/projects/1/views/1'
    },
    {
        title: 'Vercel Preview',
        href: 'https://chauncey-ai-git-develop-parli-pro.vercel.app'
    },
    {
        title: 'Vercel Project',
        href: 'https://vercel.com/parli-pro/chauncey-ai'
    },
    {
        title: 'Github Repo',
        href: 'https://github.com/parlii/chauncey-ai'
    }
];

export function DevMenu({ className }: { className?: string }) {
    return (
        <div className={cn('flex items-center justify-between', className)}>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button variant="ghost">
                        <IconGitHub />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent
                    sideOffset={8}
                    align="start"
                    className="w-[180px]"
                >
                    {externalLinks.map((link, index) => (
                        <DropdownMenuItem key={index} asChild>
                            <a
                                href={link.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex w-full items-center justify-between text-xs"
                            >
                                {link.title}
                                <IconExternalLink className="ml-auto h-3 w-3" />
                            </a>
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}
